import { render, staticRenderFns } from "./SelectBank.vue?vue&type=template&id=805cdabc&scoped=true&"
import script from "./SelectBank.vue?vue&type=script&lang=js&"
export * from "./SelectBank.vue?vue&type=script&lang=js&"
import style0 from "./SelectBank.vue?vue&type=style&index=0&id=805cdabc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805cdabc",
  null
  
)

export default component.exports